/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Adr_Preview_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "ADR preview" |
*
* @param {Player_Adr_Preview_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_adr_preview_aria_label = /** @type {((inputs?: Player_Adr_Preview_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Adr_Preview_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Apercu ADR")
	if (locale === "de") return /** @type {LocalizedString} */ ("ADR-Vorschau")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima ADR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр ADR")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa de ADR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ADR预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADRプレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एडीआर पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prévia de ADR")
	return /** @type {LocalizedString} */ ("ADR preview")
});